import React from "react";

const countryBody = (rowData) => {
  if (!rowData.context) return null;
  let details = rowData.context.ip_details || {};
  return (
    <React.Fragment>
    <span className="p-column-title">Country</span>
      <img
        alt={details.isocode}
        src={`https://cdn.ipregistry.co/flags/noto/${(details.isocode||"").toLowerCase()}.png`}
        width="16"
      />{" "}
      <span className="image-text">
        {(details.isocode||"")}
      </span>
    </React.Fragment>
  );
};

export default countryBody;
